import { render } from "./OdontogramToothModal.vue?vue&type=template&id=997c6206"
import script from "./OdontogramToothModal.vue?vue&type=script&lang=js"
export * from "./OdontogramToothModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__